export default __webpack_public_path__ + "static/media/team6.e19ca5c2.png";